import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';
import Button from '../button';

export const ExpandCollapseAllContext = React.createContext();

export default function ExpandCollapse(props) {
  const {className, children, ...rest} = props;
  const [toggleCollapsedAll, setToggleCollapsedAll] = React.useState();

  const contextValue = {
    collapsed: toggleCollapsedAll,
  };

  return (
    <ExpandCollapseAllContext.Provider value={contextValue}>
      <div className={classnames(className)} {...rest}>
        <span className="expand-collapse-all">
          <Button
            variant="link"
            onClick={() => {
              setToggleCollapsedAll(false);
            }}
          >
            <I18n t="action.expand-all" />
            &nbsp;
            <span className="fa fa-chevron-down" />
          </Button>
          <Button
            variant="link"
            onClick={() => {
              setToggleCollapsedAll(true);
            }}
          >
            <I18n t="action.collapse-all" />
            &nbsp;
            <span className="fa fa-chevron-up" />
          </Button>
        </span>
        {children}
      </div>
    </ExpandCollapseAllContext.Provider>
  );
}

ExpandCollapse.defaultProps = {};

ExpandCollapse.propTypes = {
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** An element which needs to be expanded or collapsed */
  children: PropTypes.node.isRequired,
};
